<template>
	<div class="chat-instagram-main-feed-post">
		<div class="post-message-text" v-html="post.content"></div>
		<div class="action-buttons">
			<div class="action-button copy-button" @click="onCopy">
				<span>Copy Post</span>
				<InlineSvg src="/images/icons/ic-copy-white.svg" class="icon-svg" />
			</div>
		</div>
	</div>
</template>

<script>
	import { mapGetters } from 'vuex'

	export default {
		name: 'ChatMainFeedPost',
		props: {
			post: {
				type: Object,
				required: true,
			},
		},
		computed: {
			...mapGetters('Auth', ['user']),
		},

		methods: {
			cleanHtmlContent(content) {
				const str = content
					.replace(/<p>/g, '')
					.replace(/<\/p>/g, '\n')
					.replace(/<br>/g, '\n')

				if (!str || typeof str !== 'string') return str

				const txt = document.createElement('textarea')
				txt.innerHTML = str
				return txt.value
			},
			onCopy() {
				this.$commonHelper.copyToClipboard(this.cleanHtmlContent(this.post.content), () => {
					this.$stanNotify({
						type: 'success',
						title: this.$t('Done!'),
						text: this.$t('Copied to clipboard'),
					})
				})
				this.$stanAnalytics('chat-v2-instagram-main-feed-post-copied', {
					meta: { user_id: this.user?.user_id, username: this.user?.username },
					props: {
						post_id: this.post.id,
						trigger_location: 'chat-image-viewer',
					},
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.chat-instagram-main-feed-post {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 12px;
		margin: 8px 0;

		.post-message-text {
			font-family: 'Inter', sans-serif;
		}

		.action-buttons {
			display: flex;
			gap: 8px;
			width: 100%;
		}

		.action-button {
			background: #ebebff;
			color: #6355ff;
			border: none;
			font-family: 'Inter', sans-serif;
			font-weight: 500;
			font-size: 16px;
			line-height: 110%;
			cursor: pointer;
			transition: all 0.2s ease;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 4px;

			span {
				font-family: 'Inter', sans-serif;
				font-weight: 500;
				font-size: 16px;
				line-height: 110%;
			}

			&:hover:not(:disabled) {
				background: #492ad8;
			}

			&:active:not(:disabled) {
				background: #492ad8;
			}

			&:focus-visible:not(:disabled) {
				background: #3c29a3;
			}

			&:disabled {
				opacity: 0.6;
				cursor: not-allowed;
			}

			&.copy-button {
				background: #6355ff;
				color: #ffffff;
				padding: 8px 20px;
				border-radius: 9999px;
			}
		}
		.icon-svg {
			width: 24px;
			height: 24px;
		}
	}
</style>
